import { StrictMode } from "react";
import Demos from "./demos";

function App() {
  return (
    <StrictMode>
      <div className="app">
        <Demos />
      </div>
    </StrictMode>
  );
}

export default App;
